import { muiDataGridStarted } from "../apiutils";
import { apiSlice } from "../createApiSlice";

const COST_BASE = "/costs";
const buildUrl = (endpoint) => COST_BASE + endpoint;
const API_TAG = 'Costs';

const costSlice =  apiSlice.injectEndpoints({
    endpoints: builder => ({
        getCosts: builder.query({
            query: ({ args, invalidate }) => ({
                url: buildUrl(`?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: () => [{ type: API_TAG }],
            onQueryStarted: muiDataGridStarted.bind(null, 'getCosts', API_TAG)
        }),
        getCost: builder.query({
            query: (id) => ({
                url: buildUrl(`/${id}`),
                method: 'GET',
            }),
            providesTags: (result, error, arg) => [{ type: `${API_TAG}Single`, id: arg }]
        }),
        getCostFromShipper: builder.query({
            query: (id) => ({
                url: buildUrl(`/shipper/${id}`),
                method: 'GET',
            }),
            providesTags: (result, error, arg) => [{ type: `${API_TAG}Shipper`, id: arg }]
        }),
        getReturnCostFromShipper: builder.query({
            query: (id) => ({
                url: buildUrl(`/shipper/${id}?type=return`),
                method: 'GET',
            }),
            providesTags: (result, error, arg) => [{ type: `${API_TAG}Shipper`, id: arg }]
        }),
        addOrUpdateCostFromShipper: builder.mutation({
            query: costInfo => ({
                url: buildUrl(`/shipper/${costInfo.shipperId}`),
                method: 'PUT',
                body: costInfo,
            }),
            invalidatesTags: (result, error, arg) => [{ type: `${API_TAG}Shipper`, id: arg }]
        }),
        deleteCostFromShipper: builder.mutation({
            query: costInfo => ({
                url: buildUrl(`/shipper/${costInfo.shipperId}`),
                method: 'PUT',
                body: costInfo,
            }),
            invalidatesTags: (result, error, arg) => [{ type: `${API_TAG}Shipper`, id: arg }]
        }),
        addCost: builder.mutation({
            query: costInfo => ({
                url: buildUrl(`/new`),
                method: 'POST',
                body: costInfo,
            }),
            invalidatesTags: (result, error, arg) => [{type: API_TAG}],
        }),
        updateCost: builder.mutation({
            query: costInfo => ({
                url: buildUrl(`/${costInfo.id}`),
                method: 'PUT',
                body: costInfo,
            }),
            invalidatesTags: (result, error, arg) => [{type: API_TAG }, { type: `${API_TAG}Single`, id: arg.id }],
        }),
        updateIndividualCostRule: builder.mutation({
            query: costInfo => ({
                url: buildUrl(`/${costInfo.id}/rule`),
                method: 'PUT',
                body: costInfo,
            }),
            invalidatesTags: (result, error, arg) => [{type: API_TAG }, { type: `${API_TAG}Single`, id: arg.id }],
        }),
        deleteCost: builder.mutation({
            query: id => ({
                url: buildUrl(`/${id}`),
                method: 'DELETE',
            }),
            invalidatesTags: (result, error, arg) => [{type: API_TAG }, { type: `${API_TAG}Single`, id: arg.id }],
        }),
    })
});

export const {
    useGetCostsQuery,
    useGetCostQuery,
    useGetCostFromShipperQuery,
    useGetReturnCostFromShipperQuery,
    useAddOrUpdateCostFromShipperMutation,
    useDeleteCostFromShipperMutation,
    useAddCostMutation,
    useUpdateCostMutation,
    useDeleteCostMutation,
    useUpdateIndividualCostRuleMutation,
  } = costSlice;
